export default {
  replaceMark: function (str){
    let that = this
    let index = str.indexOf('\n');
    if(index>-1){
      var f = str.substring(0,index);
      var s = str.substring(index+1,str.length);
      str = f + '<br>' + s;
      return this.replaceMark(str);
    }else{
      return str;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/replace.js